module.exports = __webpack_public_path__ + "static/media/icon_edit_disable.9b241354.svg";